import {RootState} from "../store/store";
import {OrderQueryArgs} from "./thunks";
import {QueryKey} from "./slice";

/**
 * from から to までの注文をページを指定して取得する
 * @param state
 * @param lim 1ページあたりに読み込む注文数
 * @param page 読み込むページ
 * @param sort
 */
export const selectOrdersByPage = (state: RootState, lim: number, page: number, sort: OrderQueryArgs) => {
    const offset = (page - 1) * lim;
    let fromIndex: number, toIndex: number;

    if (sort.direction === 'asc') {
        fromIndex = (state.orders.fromIndex ?? 1) + offset;
        toIndex = fromIndex + lim - 1;
    } else {
        toIndex = (state.orders.toIndex ?? state.info.orderInfo.data?.latestIndex ?? 1) - offset;
        fromIndex = toIndex - lim + 1;
    }

    return state.orders.data
      .filter(o => o.index >= fromIndex && o.index <= toIndex
        && (sort.from === undefined || o.created_at.toMillis() > sort.from.getTime())
        && (sort.to === undefined || o.created_at.toMillis() < sort.to.getTime())
      )
      .sort((a, b) => sort.direction === 'asc' ? a.index - b.index : b.index - a.index);
}

/**
 * 注文履歴の合計ページ数を返す
 * @param state
 * @param lim 1ページあたりに読み込む注文数
 */
export const selectOrderMaxPage = (state: RootState, lim: number) => Math.ceil(((state.orders.toIndex ?? 0) - (state.orders.fromIndex ?? 0)) / lim);

/**
 * fetchOrder() で使用するパラメータを取得する
 * @param state
 */
export const selectOrderQueryKey = (state: RootState): QueryKey => ({
  fetchedPages: state.orders.fetchedPages,
  fromIndex: state.orders.fromIndex,
  toIndex: state.orders.toIndex,
});

export const selectOrderStatus = (state: RootState) => state.orders.status;
